// @flow

import styled from 'styled-components';
import type { Theme } from '../../../../types';
import { SEMIBOLD } from '../../../../helpers/fontWeight';

export default styled<any, Theme>('div')`
  font-weight: ${SEMIBOLD};
  font-size: ${props => props.theme.carblock.capsule.fontSize};
  height: 2.5em;
  border-radius: 1.5em;
  padding: 0 2em;
  color: ${props => props.theme.carblock.capsule.color};
  background-color: ${props => props.theme.carblock.capsule.backgroundColor};
  display: flex;
  align-items: center;
  justify-content: center;
`;
